import { styled } from '@mui/material/styles';
import Button, { buttonClasses } from '@mui/material/Button';
import { collapseClasses } from './collapseClasses';

export const CollapseRoot = styled('div', {
  name: 'AFCollapse'
})(({ theme, isOpen }) => ({
  [`& .${collapseClasses.contentWrapper}`]: {
    transition: 'padding 100ms ease-in-out',
    padding: theme.spacing(isOpen ? 0.5 : 0, 0.5)
  }
}));

export const ButtonTitleRoot = styled(Button, {
  shouldForwardProp: prop => prop !== 'buttonVariant',
  name: 'AFCollapseButtonTitle'
})(({ theme, buttonVariant }) => ({
  ...(buttonVariant !== 'text' && {
    fontSize: '18px',
    lineHeight: '28px',
    padding: theme.spacing(0.5),
    display: 'flex',
    justifyContent: 'space-between',
    [`& .${buttonClasses.startIcon}`]: {
      margin: 0
    }
  }),
  color:
    buttonVariant === 'text'
      ? theme.palette.primary.main
      : theme.palette.text.primary,
  '&[disabled]': {
    [`& .${collapseClasses.expandIcon}`]: {
      color: theme.palette.action.disabled
    }
  },
  [`& .${collapseClasses.expandIcon}`]: {
    color:
      buttonVariant === 'text'
        ? theme.palette.primary.main
        : theme.palette.grey[700],
    margin: buttonVariant === 'text' ? undefined : theme.spacing(0, 1)
  }
}));
